<form [formGroup]="form">
  <section>
    <div class="fields-container">
      <div class="field-control">
        <app-text-field
          [control]="form.get('companyNameEn')"
          [label]="'COMPANY.NAME_EN' | translate"
          [validationMessages]="{
            english: 'VALIDATION_MSG.EN_LETTERS' | translate
          }"
          [maxlength]="100"
        />
      </div>

      <div class="field-control">
        <app-text-field
          [control]="form.get('companyNameAr')"
          [label]="'COMPANY.NAME_AR' | translate"
          [validationMessages]="{
            arabic: 'VALIDATION_MSG.AR_LETTERS' | translate
          }"
          [maxlength]="100"
        />
      </div>

      <div class="field-control">
        <app-text-field
          [control]="form.get('companyEmail')"
          [label]="'COMPANY.EMAIL' | translate"
          [validationMessages]="{
            email: 'VALIDATION_MSG.VALID_EMAIL' | translate
          }"
          [maxlength]="100"
        />
      </div>

      <div class="field-control">        
        <!-- [label]="'MEDIATION.FORM.Mobile' | translate" -->
        <app-mobile-number
          [control]="form.get('compnayPhone')"
          [label]="'COMPANY.PHONE' | translate"
          [countryCodeControl]="form.get('countryCode')"
          [validationMessages]="{
            mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
            uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
          }"
        />
      </div>

      <div class="field-control">
        <app-option-field
          [control]="form.get('companyCountry')"
          [label]="'COMPANY.COUNTRY' | translate"
          [lovType]="lookupKey.COUNTRY"
          [country]="true"
        ></app-option-field>
      </div>
      <div class="field-control">
        <app-text-field
          [control]="form.get('companyCity')"
          [label]="'COMPANY.CITY' | translate"
        />
      </div>
      <div class="field-control">
        <app-text-field
          [control]="form.get('companyAddress')"
          [label]="'COMPANY.ADDRESS' | translate"
        />
      </div>
      <div class="field-control">
        <app-text-field
          [control]="form.get('companyPoBox')"
          [label]="'COMPANY.PO_BOX_NUM' | translate"
        />
      </div>
    </div>
  </section>
  <!----- SUBMIT actions --------->
  <div class="buttons-group">
  @if(showAction){
    <app-button
      type="button"
      classesName="btn-edge-cut  btn-width-auto"
      [label]="'BUTTONS.ADD' | translate"
      (onBtnClick)="submit()"
    />
    <app-button
      type="button"
      classesName="card-edge-cut-white btn-width-auto"
      [label]="'BUTTONS.CLOSE' | translate"
      (onBtnClick)="close()"
    />    
    }
  </div>
</form>
